module.exports = __webpack_public_path__ + "img/10.bae00d45.webp";